export default {
	init() {
		document.addEventListener("DOMContentLoaded", this.bindEvents);
	},

	bindEvents() {
		this.widgets = document.querySelectorAll("[data-copy-url]");

		if (!this.widgets.length) {
			return;
		}

		Array.from(this.widgets).forEach((element) => {
			element.addEventListener("click", () => {
				navigator.clipboard.writeText(window.location.href);
				element.classList.add("success");
                setTimeout(function() {
                    element.classList.remove("success");
                }, 3000);
			});
		});
	},
};